import styled from 'styled-components';
import dt from '../../../../../shared/theme';

const Aside = styled.aside`
  & > h2 {
    font: ${props => dt(props).theme.fontWeightDccc} 20px/24px ${props => dt(props).theme.fontFamilyBody};
    text-transform: uppercase;
    margin-bottom: 8px;
  }
`;

export default Aside;
